export const LOCAL_STORAGE_KEYS = {
  AUTH_EHEALTH: 'auth_ehealth',
  FEATURES: 'features',
};
